

export const formatModuleName = (name: string): string => {
  const cleanName = name.replaceAll("_", " ");
  let formattedName = `${cleanName[0].toUpperCase()}${cleanName.slice(1)}`;

  // Add "Skills" for these modules
  const skillsModules = ["money", "people", "entrepreneurial", "work"];

  if (skillsModules.includes(name.toLowerCase())) {
    formattedName += " Skills";
  }

  return formattedName;
};
// export const obfusticateEmail = (email: string): string => {
//   if (email.length === 0) {
//     return "";
//   }

//   const [userInfo, domain] = email.split("@");

//   const obfusticateValue = (value: string, hideBeginning: boolean): string => {
//     if (value.length < 2) {
//       return value;
//     }

//     if (value.length < 3) {
//       if (hideBeginning) {
//         return `*${value[1]}`;
//       }
//       return `${value[0]}*`;
//     }

//     const startCount = value.length - 2;
//     if (hideBeginning) {
//       return `${"*".repeat(startCount)}${value.substring(
//         value.length - 3,
//         value.length
//       )}`;
//     }
//     return `${value.substring(0, 2)}${"*".repeat(startCount)}`;
//   };

//   const newUserInfo = userInfo
//     .split(".")
//     .map((value) => obfusticateValue(value, false))
//     .join(".");

//   const domainParts = domain.split(".");
//   domainParts[0] = obfusticateValue(domainParts[0], true);
//   const newDomain = domainParts.join(".");

//   return `${newUserInfo}@${newDomain}`;
// };
